import { NgModule } from '@angular/core';
import { AngularFireModule } from '@angular/fire';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireFunctionsModule } from '@angular/fire/functions';
import { LoginViaThirdPartiesModule } from './login-via-third-parties/login-via-third-parties.module';
import { SurveyTokensModule } from './tokens/tokens.module';


@NgModule({
  imports: [
    LoginViaThirdPartiesModule,
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFireFunctionsModule,
    SurveyTokensModule
  ],
  exports: [
    LoginViaThirdPartiesModule,
    AngularFireModule,
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFireFunctionsModule
  ]
})
export class SurveyServiceModule {
  static forRoot (env:{
    serverHost:string,
    firebase:any,
    schoolbelleLoginFrontHost:string
  }) {
    return {
      ngModule:SurveyServiceModule,
      providers:[
        ...LoginViaThirdPartiesModule.forRoot().providers,
        ...SurveyTokensModule.forRoot(env).providers,
        ...AngularFireModule.initializeApp(env.firebase).providers,        
      ]
    }
  }
}


